<script lang="ts" setup>
import type { Ratio } from '~/types/image'
import type { BlockAsset } from '~/types/storyblok/block-asset'
import type { PromoCard } from '~/types/storyblok/promo-card';
import type { trackBlockClickEmit } from '~/types/track-block-click';

const props = defineProps<{
  asset: BlockAsset
  dataParentPosition: number
  blok: PromoCard
  url: string 
}>()
const emit = defineEmits<trackBlockClickEmit>()
const elementType = computed(() => props.blok.link.cached_url ? resolveComponent('NuxtLink') : 'div')

</script>

<template>
    <component
    :is="elementType"
    v-editable="blok"
    :to="$url(url)"
    @click="() => emit('trackBlockClick', $url(url), 'link')"
  >
  <ImageResponsive
    provider="storyblok"
    :src="asset.url || ''"
    :alt="asset.alt"
    :large-asset="asset.url"
    :breakpoint="0"
    :lazy="dataParentPosition !== 0"
    :ratio="asset.aspectRatio?.join(':') as Ratio"
    object-fit="cover"
  />
  </component>
</template>
